import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center justify-between p-4" };
const _hoisted_2 = { class: "text-xl font-bold" };
const _hoisted_3 = { class: "flex gap-4" };
const _hoisted_4 = { class: "p-8 text-center text-gray-600" };
import { computed, ref } from 'vue';
import { useProjectConfig } from '@shared/composables/useProjectConfig';
import { useCartStore } from '@shared/composables/useCartStore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RestaurantLayoutBase',
    props: {
        hideHeader: { type: Boolean, default: false },
        hideFooter: { type: Boolean, default: false },
        headerClasses: { default: '' },
        mainClasses: { default: '' },
        footerClasses: { default: '' },
        layoutClasses: { default: '' },
        showFloatingCart: { type: Boolean, default: true }
    },
    setup(__props) {
        // Project Config
        const { config } = useProjectConfig();
        // Cart Store
        const cartStore = useCartStore();
        const cartCount = computed(() => cartStore.itemCount);
        // Current Year for copyright
        const currentYear = computed(() => new Date().getFullYear());
        // Cookie acceptance (basic implementation)
        const cookiesAccepted = ref(false);
        const acceptCookies = () => {
            cookiesAccepted.value = true;
            localStorage.setItem('cookies-accepted', 'true');
        };
        // Check if cookies already accepted
        if (typeof window !== 'undefined') {
            cookiesAccepted.value = localStorage.getItem('cookies-accepted') === 'true';
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["restaurant-layout", _ctx.layoutClasses])
            }, [
                _createCommentVNode(" Header "),
                (!_ctx.hideHeader)
                    ? (_openBlock(), _createElementBlock("header", {
                        key: 0,
                        class: _normalizeClass(["restaurant-layout__header", _ctx.headerClasses])
                    }, [
                        _renderSlot(_ctx.$slots, "header", {
                            config: _unref(config),
                            cartCount: cartCount.value
                        }, () => [
                            _createCommentVNode(" Fallback: Project should provide header "),
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(config)?.restaurant.shortName || 'Restaurant'), 1 /* TEXT */),
                                _createElementVNode("nav", _hoisted_3, [
                                    _renderSlot(_ctx.$slots, "navigation")
                                ])
                            ])
                        ])
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Main Content "),
                _createElementVNode("main", {
                    class: _normalizeClass(["restaurant-layout__main", _ctx.mainClasses])
                }, [
                    _renderSlot(_ctx.$slots, "default")
                ], 2 /* CLASS */),
                _createCommentVNode(" Footer "),
                (!_ctx.hideFooter)
                    ? (_openBlock(), _createElementBlock("footer", {
                        key: 1,
                        class: _normalizeClass(["restaurant-layout__footer", _ctx.footerClasses])
                    }, [
                        _renderSlot(_ctx.$slots, "footer", { config: _unref(config) }, () => [
                            _createCommentVNode(" Fallback: Basic footer "),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("p", null, "© " + _toDisplayString(currentYear.value) + " " + _toDisplayString(_unref(config)?.restaurant.name || 'Restaurant'), 1 /* TEXT */)
                            ])
                        ])
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Floating Cart Button (optional) "),
                _renderSlot(_ctx.$slots, "floating-cart", {
                    cartCount: cartCount.value,
                    isVisible: _ctx.showFloatingCart
                }, () => [
                    _createCommentVNode(" Project can provide custom floating cart button ")
                ]),
                _createCommentVNode(" Cookie Banner (optional) "),
                _renderSlot(_ctx.$slots, "cookie-banner", { acceptCookies: acceptCookies }, () => [
                    _createCommentVNode(" Project can provide custom cookie banner ")
                ])
            ], 2 /* CLASS */));
        };
    }
});
